import { render, staticRenderFns } from "./patternplate.vue?vue&type=template&id=9235fe6e&scoped=true"
import script from "./patternplate.vue?vue&type=script&lang=js"
export * from "./patternplate.vue?vue&type=script&lang=js"
import style0 from "./patternplate.vue?vue&type=style&index=0&id=9235fe6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9235fe6e",
  null
  
)

export default component.exports